import generalSettingsStore from '@/stores/generalSettingsStore';

export const getSettings = () => {
  return generalSettingsStore.settings;
};

export const useSettings = () => {
  return {
    settings: generalSettingsStore.settings,
  };
};